import React, { PropTypes } from 'react';
import ShowReporting from '../components/Reporting/ShowReporting';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

class ReportingPage extends React.Component {
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="settings component" style={authPage}>
        <ShowReporting />
      </div>
    );
  }
}


ReportingPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

export default (ReportingPage);



// WEBPACK FOOTER //
// ./src/containers/ReportingPage.js